// Раскрытая строка списка должна быть видно где начинается и где кончается.
//
// Списки идут плотно, строка в строку — это правильно, пока они закрыты.
// Но стоит раскрыть одну, и её состав визуально слипается с соседями: не
// понять, эти три позиции принадлежат раскрытой строке или следующей.
// Кладовщик читает чужой состав и считает, что отдал не то.
//
// Поэтому раскрытая строка отходит от соседей, обводится своим цветом и
// приподнимается тенью — как вынутая из стопки карточка.
export function openCard(open, color = 'var(--accent)') {
  if (!open) return {};
  return {
    border: `1px solid ${color}`,
    borderLeftWidth: 4,
    borderLeftColor: color,
    background: 'var(--input)',
    boxShadow: '0 6px 20px rgba(0,0,0,.22)',
    // Отступ сверху и снизу — то, что отделяет её от соседних строк
    margin: '10px 0',
    position: 'relative',
    zIndex: 1,
  };
}

// Разделитель между шапкой строки и её составом. Внутри раскрытой карточки
// он должен быть заметнее обычной линии: иначе состав читается как
// продолжение заголовка.
export const openDivider = (color = 'var(--accent)') => ({
  marginTop: 9,
  paddingTop: 9,
  borderTop: `1px dashed ${color}`,
});
